import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined'
import { useTranslations } from 'next-intl'

interface DestinationOverviewProps {
    title: string
    overview: string
    travelTips: string[]
}

const DestinationOverview: React.FC<DestinationOverviewProps> = ({ title, overview, travelTips }) => {
    const t = useTranslations('destinationPage')
    return (
        <Box component="section" sx={{ mb: 4 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.1rem' }, mb: 1.5 }}
            >
                {title}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8, mb: 2 }}>
                {overview}
            </Typography>

            {travelTips.length > 0 && (
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                        <TipsAndUpdatesOutlinedIcon sx={{ fontSize: 18, color: 'warning.main' }} />
                        <Typography component="h3" variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {t('travelTips')}
                        </Typography>
                    </Box>
                    <List dense disablePadding sx={{ listStyleType: 'disc', pl: 2.5 }}>
                        {travelTips.map((tip, i) => (
                            <ListItem key={i} sx={{ py: 0.25, px: 0, display: 'list-item' }}>
                                <ListItemText
                                    primary={tip}
                                    primaryTypographyProps={{ variant: 'body2', color: 'text.secondary', lineHeight: 1.7 }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            )}
        </Box>
    )
}

export default DestinationOverview
export type { DestinationOverviewProps }
